/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdFrequencyCapDto } from "./AdFrequencyCapDto";
export type CreateAdDto = {
  /**
   * 광고그룹 ID
   */
  adGroupId: string;
  /**
   * 캠페인 ID
   */
  campaignId: string;
  /**
   * 광고주 ID
   */
  advertiserId: string;
  /**
   * 광고명
   */
  name: string;
  /**
   * 광고 타입
   */
  type: CreateAdDto.type;
  /**
   * 광고 배지 표시 여부
   */
  showAdBadge?: boolean;
  /**
   * 광고 콘텐츠 (타입별 다른 구조)
   */
  content: Record<string, any>;
  /**
   * 프리퀀시 캡 설정
   */
  frequencyCap?: AdFrequencyCapDto;
  /**
   * 상태
   */
  status?: CreateAdDto.status;
};
export namespace CreateAdDto {
  /**
   * 광고 타입
   */
  export enum type {
    HALF_VIEW_CPE = "HALF_VIEW_CPE",
    HALF_VIEW_CPM = "HALF_VIEW_CPM",
    LIGHT_VIEW_CPE = "LIGHT_VIEW_CPE",
    LIGHT_VIEW_CPM = "LIGHT_VIEW_CPM",
    CPQ = "CPQ",
    TOP_BANNER = "TOP_BANNER",
    EXCHANGE = "EXCHANGE",
    QUIZ_CREATION = "QUIZ_CREATION",
  }
  /**
   * 상태
   */
  export enum status {
    DRAFT = "DRAFT",
    ACTIVE = "ACTIVE",
    PAUSED = "PAUSED",
    COMPLETED = "COMPLETED",
  }
}
